import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homenine-courses',
  templateUrl: './homenine-courses.component.html',
  styleUrls: ['./homenine-courses.component.scss']
})
export class HomenineCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
